/** @jsxImportSource @emotion/react */
import { List, ListItem, Typography } from '@quickbit/qb-design-system';
import { SettlementPaymentDetails } from 'tabs/AccountingSettlement/types';

interface Props {
  payments: SettlementPaymentDetails[];
}

export const Payments = ({ payments }: Props) => {
  if (!payments.length) return null;
  return (
    <>
      <Typography variant="subtitle">Payments</Typography>
      <List>
        {payments.map((p) => (
          <ListItem
            key={p.uuid}
            title={`Paid: ${p.paidAt.toLocaleDateString()} ${p.paidAt.toLocaleTimeString()}`}
            subtitle={p.reference}
            content={p.euroAmount.toString() + '€'}
            subcontent={
              p.usdtAmount
                ? p.usdtAmount.toString() + ' USDT'
                : p.usdcAmount
                  ? p.usdcAmount.toString() + ' USDC'
                  : ''
            }
          />
        ))}
      </List>
    </>
  );
};
